export const Constants = Object.freeze({
  WELCOME_MESSAGE: 'Welcome to the react boilerplate',
});

export const UI_FRAMEWORK = Object.freeze({
  REACT_UI: 'react_ui',
});

// Default export for easier imports
export default Constants;
